// src/services/api/permissions.js
import { apiClient } from './base';

export const getPermissions = async () => {
  try {
    const response = await apiClient.get('/permissions');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPermissionsByRole = async (roleId) => {
  try {
    const response = await apiClient.get(`/permissions/role/${roleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateRolePermissions = async (roleId, permissionKeys) => {
  try {
    const response = await apiClient.put(`/permissions/role/${roleId}`, {
      permissionKeys
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};